@let isMapVisible = store.isMapTimelineVisible();
<div class="timecard-detail-view flex layout-column" [class.map-fullscreen]="store.isMapFullscreen()">

  <app-timecard-detail-header [isAgentView]="isAgentView()"
                              [fromDate]="store.fromDate()"
                              [configTimeZone]="configTimeZone"
                              [isMapTimelineVisible]="isMapVisible"
                              [isRoutePanelVisible]="store.isRoutePanelVisible()"
                              [isAddStopDisabled]="store.isStopButtonDisabled()"
                              [addStopHint]="addStopHint()"
                              (back)="onBack()"
                              (browseDay)="store.browseDay($event)"
                              (dateChange)="store.setDate($event)"
                              (toggleMapTimeline)="store.toggleMapTimeline()"
                              (toggleRoutePanel)="store.toggleRoutePanel()"
                              (addStop)="onAddStop()">
    <ng-content select="[timecard-agent-select]"></ng-content>
  </app-timecard-detail-header>

  <app-timecard-detail-summary [employee]="store.employee()"
                               [groupStatus]="store.group()?.status"
                               [branchReferences]="store.group()?.branchReferences || []"
                               [aggregatedData]="store.aggregatedData()"
                               [canEditAdminTime]="store.canEditAdminTime()"
                               (editAdminTime)="onEditAdminTime()">
  </app-timecard-detail-summary>

  <bz-divider></bz-divider>

  <!-- Main Content Area -->
  <div #mainContent class="main-content flex layout-row">

    <!-- Left Panel - Stops Table -->
    <div id="timecard-detail-left-panel"
         class="stops-panel layout-column"
         [class.no-border]="!isMapVisible"
         [class.width-100]="!isMapVisible"
         [style.width]="leftPanelWidth()">
      <app-timecard-shift-list [shifts]="store.shifts()"
                               [leaves]="store.leaves()"
                               [selectedShiftId]="store.selectedShiftId()"
                               [selectedTaskId]="store.selectedTaskId()"
                               [analysisMap]="store.analysisMap()"
                               [entryAnalysisMap]="store.entryAnalysisMap()"
                               [statusHistoryShiftIds]="store.statusHistoryShiftIds()"
                               [siteDistanceUnit]="siteDistanceUnit"
                               [configTimeZone]="configTimeZone"
                               [isStatusChanging]="store.isStatusChanging()"
                               [isRefreshingData]="store.isRefreshingData()"
                               [serviceHrefs]="serviceHrefs()"
                               (shiftSelect)="store.selectShift($event)"
                               (stopSelect)="onSelectStop($event)"
                               (editEntry)="onEditEntry($event)"
                               (openHistory)="onOpenHistory($event)"
                               (openStatusHistory)="onOpenStatusHistory($event)"
                               (changeStatus)="onChangeStatus($event)"
                               (refreshData)="onRefreshData($event)"
                               (archiveStop)="onArchiveStop($event)">
      </app-timecard-shift-list>
    </div>

    <!-- Resizer -->
    @if (isMapVisible) {
      <div class="horizontal-draggable flex layout-row layout-align-start-center"
           appBringozIdGenerator="timecard-detail-resizer"
           (mousedown)="onResizeStart($event)">
      </div>
    }

    <!-- Right Panel - Map and Timeline. The map and the timeline are AngularJS widgets projected from the
         shell, so the panel is only hidden here; the shell creates and destroys them. -->
    <div class="map-timeline-panel flex layout-column" [class.timecard-panel-hidden]="!isMapVisible">

      @if (store.isShowLegend()) {
        <div class="legend fade-element-in-only">
          <div class="layout-row layout-align-start-center">
            <bz-icon class="margin-right-5 secondary-101" [icon]="icons.info"></bz-icon>
            <span class="br-body-2 font-weight-600 grey-101">{{ 'Legend' | translate }}</span>
            <span class="flex"></span>
            <bz-button variant="tertiary" tone="primary" size="fit"
                       appBringozIdGenerator="timecard-detail-legend-close-button"
                       [ariaLabel]="'Close' | translate"
                       (clicked)="store.setShowLegend(false)">
              <bz-icon [icon]="icons.close"></bz-icon>
            </bz-button>
          </div>
          <bz-divider class="margin-top-5 margin-bottom-5"></bz-divider>
          <div class="layout-row layout-align-start-center">
            <img src="/assets/images/map/actual-route-line.svg" alt=""/>
            <span class="br-body-2 font-weight-400 grey-101 margin-left-10">{{ 'Actual Route' | translate }}</span>
          </div>
          <div class="layout-row layout-align-start-center">
            <img src="/assets/images/map/planned-route-line.svg" alt=""/>
            <span class="br-body-2 font-weight-400 grey-101 margin-left-10">{{ 'Planned Route' | translate }}</span>
          </div>
        </div>
      }

      <!-- Map -->
      <div class="map-container"
           [class.flex-70]="store.isRoutePanelVisible()"
           [class.flex-100]="!store.isRoutePanelVisible()">
        <ng-content select="[timecard-map]"></ng-content>
        <bz-button class="map-fullscreen-button" variant="outline" tone="primary" size="fit"
                   appBringozIdGenerator="timecard-detail-map-fullscreen-button"
                   [ariaLabel]="'Fullscreen' | translate"
                   (clicked)="store.toggleMapFullscreen()">
          <bz-icon [icon]="icons.fullscreen"></bz-icon>
        </bz-button>
      </div>

      <!-- Timeline -->
      <div class="timeline-container flex-30" [class.timecard-panel-hidden]="!store.isRoutePanelVisible()">
        <ng-content select="[timecard-timeline]"></ng-content>
      </div>
    </div>
  </div>

  @if (store.isLoadingData()) {
    <div class="timecard-detail-loader">
      <bz-spinner size="lg" [label]="'Loading' | translate"></bz-spinner>
    </div>
  }

</div>
